import { Users, MessageCircle } from 'lucide-react'
import type { ChatMode } from '@/types/message'

interface MessageEmptyStateProps {
  chatMode: ChatMode
}

export function MessageEmptyState({ chatMode }: MessageEmptyStateProps) {
  return (
    <div className="text-center py-16 px-4">
      <div className="w-20 h-20 mx-auto bg-game-tertiary dark:bg-zinc-800/50 rounded-2xl flex items-center justify-center mb-4 border border-game-border-primary dark:border-zinc-700/50 shadow-lg">
        {chatMode === 'private' ? (
          <MessageCircle className="h-10 w-10 text-violet-600 dark:text-violet-400" />
        ) : (
          <Users className="h-10 w-10 text-violet-600 dark:text-violet-400" />
        )}
      </div>
      <p className="text-lg font-semibold mb-2 text-game-primary dark:text-zinc-200">
        {chatMode === 'private' ? 'Chat Privado' : 'Bem-vindo a mesa!'}
      </p>
      <p className="text-sm text-game-muted max-w-xs mx-auto">
        {chatMode === 'private'
          ? 'Suas mensagens sao privadas: apenas voce e o destinatario as veem.'
          : 'Seja o primeiro a enviar uma mensagem para comecar a aventura.'
        }
      </p>
    </div>
  )
}
